// useMemory.js
// Custom hook for loading the user's central memory record from the backend.
// Calls GET /memory via api.js on mount and provides a refresh function.
// Returns: { memory, loading, error, refreshMemory }

import { useState, useEffect } from 'react';
import { getMemory } from '../api';

export function useMemory() {
  const [memory, setMemory] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  async function fetchMemory() {
    setLoading(true);
    setError(null);
    try {
      const data = await getMemory();
      setMemory(data);
    } catch (err) {
      // Memory fetch failure is non-fatal — the dashboard renders with
      // all pillars shown as incomplete.
      setError(err.message);
      setMemory(null);
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    fetchMemory();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return { memory, loading, error, refreshMemory: fetchMemory };
}
